wbApp.controller('EmailTemplatesAttachmentsDetailCtrl', ['$scope', '$translate', '$filter', '$q', 'emailAttachmentsSvc', 'tenantInfo',
function ($scope, $translate, $filter, $q, emailAttachmentsSvc, tenantInfo) {

    var fileManagerInstance;
    var chunkSize = 1024 * 1024 * 8;   // 8 MB

    $scope.localeAlias = tenantInfo.languageAlias || 'cs';


    $scope.fileManagerOptions = {
        fileSystemProvider: new DevExpress.fileManagement.CustomFileSystemProvider({
            getItems: function(pathInfo) {
                return emailAttachmentsSvc.getFiles($scope.model.documentTemplateType, $scope.model.emailCategory, $scope.localeAlias).$promise;
            },
            downloadItems: function (items) {
            },
            deleteItem: function (item) {
                return emailAttachmentsSvc.deleteFile($scope.model.documentTemplateType, $scope.model.emailCategory, item.path, $scope.localeAlias).$promise;
            },
            uploadFileChunk: function (fileData, uploadInfo, destinationDirectory) {
                var fileSize = fileData.size;
                var contentType = fileData.type;
                var chunkCount = uploadInfo.chunkCount;

                var deffered = $q(function (resolve, reject) {
                    if (uploadInfo.chunkIndex === 0) {
                        var filePath = destinationDirectory.path ? destinationDirectory.path + "/" + fileData.name : fileData.name;
                        emailAttachmentsSvc.getUploadUrl($scope.model.documentTemplateType, $scope.model.emailCategory, filePath, $scope.localeAlias).$promise.then(function (uploadUrl) {
                            uploadInfo.customData.accessUrl = uploadUrl.url;
                            resolve();
                        });
                    }
                    else {
                        resolve();
                    }
                });

                return $q(function (resolve, reject) {
                    deffered.then(function () {

                        var chunkSize = uploadInfo.chunkBlob.size;
                        var chunkFirstByte = uploadInfo.bytesUploaded;
                        var chunkLastByte = uploadInfo.bytesUploaded + uploadInfo.chunkBlob.size - 1;
                        var totalObjectSize = fileSize;

                        $.ajax({
                            url: uploadInfo.customData.accessUrl,
                            type: 'PUT',
                            contentType: contentType,
                            contentLength: uploadInfo.chunkBlob.size,
                            headers: {
                                'Content-Range': "bytes " + chunkFirstByte + "-" + chunkLastByte + "/" + fileSize
                            },
                            data: uploadInfo.chunkBlob,
                            crossDomain: true,
                            processData: false,
                            success: function (res) {
                                resolve();
                            },
                            error: function (err) {
                                if (err.status == 308) { // Continue with next chunk    
                                    resolve();
                                } else {
                                    reject(err);
                                }
                            }
                        });
                    });
                });
            },
            nameExpr: 'fileName',
            sizeExpr: 'fileSize',
            keyExpr: 'fileName',
            dateModifiedExpr: "createdAtUtc"
        }),
        permissions: {
            download: false,
            create: false,
            delete: true,
            upload: true
        },
        selectionMode: "single",
        upload: {
            maxFileSize: (1024 * 1024) * 20, // 20 MB object limit
            chunkSize: chunkSize
        },
        onContentReady: function (e) {
            fileManagerInstance = e.component;
        },
        itemView: {
            mode: "details",
            showFolders: false,
            showParentFolder: false
        }
    }
}]);
